import services from './services';
import {
	lg,
	cloneDeep,
	util,
	isCorrectVal,
	isDate
} from 'utils';
import NProgress from 'nprogress';
import modalDialog from './modalDialog/index.vue'
export default {
	mixins: [services],
	components: {
		modalDialog
	},
	data() {
		return {
			loading: false,
			lists: [],
			pageIndex: 1,
			pageSize: 10,
			totalSize: '',
			sels: [], //列表选中列
			pageSizes: [10, 20, 50],
			//query: this.getFormData()

		}
	},
	methods: {
		getFormData() {
			return cloneDeep({
				OrderCode: "",
				UserName: "",
				startDate: "",
				endDate: "",
				endDate: "",
				userTel: '',
				babyName: '',
				babyId: '',

			});
		},
		//编辑订单
		handleEdit(index, row) {
			this.$refs.refsModalDialog.show({
				Id: row.Id,
				title: '编辑进度选项',
				isEdit: true
			})
		},
		addFn() {
			this.$refs.refsModalDialog.show({
				title: '添加进度选项',
			})
		},
		// 禁止
		handleDisable(index, row) {
			this.OptionDisable(row.Id)
		},
		// 启用
		handleEnable(index, row) {
			this.OptionEnable(row.Id)
		},
		//查询
		onQuerySubmit: function () {
			this.pageIndex = 1;
			this.getList();
		},
		//查询功能
		handleSizeChange: function (val) {
			this.pageSize = val;
			this.getList();
		},
		onQueryClean: function () {
			this.getList();
		},
		handleCurrentChange: function (val) {
			this.pageIndex = val;
			this.getList();
		}
	},
	created() {
		this.getList();
	},

}


// WEBPACK FOOTER //
// ./src/pages/Network/checkList/vm.js